module.exports = __webpack_public_path__ + "img/neckline length.6eaa3cc1.png";